import React, { createContext, useContext, useState } from "react";

const CurrentIdContext = createContext(null);

export function CurrentIdProvider({ children }) {
  const [id, setId] = useState(null);

  function setCurrentId(newItem) {
    setId((currentItem) => {
      currentItem = newItem;
      return newItem;
    });
  }

  return (
    <CurrentIdContext.Provider value={{ currentId: id, setCurrentId }}>
      {children}
    </CurrentIdContext.Provider>
  );
}

export function useCurrentId() {
  const context = useContext(CurrentIdContext);

  if (!context) {
    throw new Error(`"useCurrentId" must be called inside a "CurrentIdProvider"`);
  }

  return context;
}
